<script>
  import settings from '../config';
</script>

<div id="ga">
  {#if settings && settings.env === 'production'}
    <!-- Global site tag (gtag.js) - Google Analytics -->
    <script
      async
      src="https://www.googletagmanager.com/gtag/js?id=G-4LQ5L25L8P">

    </script>
    <script>
      window.dataLayer = window.dataLayer || [];

      function gtag() {
        dataLayer.push(arguments);
      }

      gtag('js', new Date());
      gtag('config', 'G-4LQ5L25L8P');
    </script>
    <!-- end of google analytics -->
  {/if}
</div>

<style>

</style>
